export const iconFontAwesomeConstructionTruckPickup = (
	<i className="fa-solid fa-truck-pickup"></i>
);
